import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import {
 GetSalesOrderGridData
} from "../../../../services/SalesOrderService";
import SalesOrderSearchResult from "./HistoricalOrderSearchResult";
import HistoricalOrderFilters from "./HistoricalOrderFilters";
import salesOrderSearchFormLayout from "../salesOrdersTab/SalesOrderSearchFormLayout";
import { OM } from "../../../../../const/constants";
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const HistoricalOrderTab = (props) => {
    const orderStatus = '1';
    const getSalesOrderUrl = "om/SaleOrder/SalesOrderSearch";
    const [dataSource, setDataSource] = useState(null);
    var accessToken = props.oidc.user.access_token;
    const searchData =  (formFields) => {
        var resultData =  GetSalesOrderGridData(accessToken, getSalesOrderUrl, formFields, orderStatus,salesOrderSearchFormLayout);
        setDataSource(resultData);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <HistoricalOrderFilters searchData={searchData} />
                        <SalesOrderSearchResult data={dataSource}/>
                        
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HistoricalOrderTab);